import React, { useEffect } from "react";
import { Tooltip } from "bootstrap";

export function CardExpandToggler(props) {
  const tooltipRef = React.createRef();

  useEffect(() => {
    new Tooltip(tooltipRef.current, {
      title: "Expand / Compress",
      placement: "bottom",
      trigger: "hover",
      container: "body",
    });
  });

  function toggleCardExpand(e) {
    e.preventDefault();

    var target = e.target.closest(".card");
    var targetClass = "card-expand";

    if (
      document.body.classList.contains(targetClass) &&
      target.classList.contains(targetClass)
    ) {
      target.removeAttribute("style");
      target.classList.remove(targetClass);
      document.body.classList.remove(targetClass);
    } else {
      document.body.classList.add(targetClass);
      target.classList.add(targetClass);
    }

    window.dispatchEvent(new Event("resize"));
  }

  return (
    <a
      href="#/"
      onClick={toggleCardExpand}
      ref={tooltipRef}
      className="text-theme  text-decoration-none"
    >
      Toggle Fullscreen <i className="bi bi-fullscreen"></i>
    </a>
  );
}
